import React, { Component } from "react";
import { getEvents, updateCurrentPage } from "../store/events";
import { getCurrentUser } from "../store/auth";
import { connect } from "react-redux";
// import Image from "react-image-resizer";
// import Image from "react-bootstrap/Image";
import { sortList } from "./common/helpers";
import Events, {mapStateToProps, mapDispatchToProps} from "./events";


class AllEvents extends Events {

  async componentDidMount() {
    
    if (this.getPrevPath() !== "/imagesFull"){
      try {
        
        await this.props.getEvents();
        await this.props.getCurrentUser();
      
      } catch (err) {
        console.log(err.message);
      }
    }
    
    const activeEvents = this.props.events.filter(event=>event.active===true);

    let comingEvents = activeEvents.filter((event) => {
      return (
        new Date(event.dateTime) >= new Date().setDate(new Date().getDate() - 2)
      );
    });

    let pastEvents = activeEvents.filter(
      (event) => !comingEvents.includes(event)
    );

    comingEvents = sortList(comingEvents, "dateTime");
    pastEvents = sortList(pastEvents, "dateTime", true);

    this.setState({ events: [...comingEvents, ...pastEvents], 
                    updateCurrentPage:this.props.updateCurrentPage, 
                    currentPage:this.props.currentPage });
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllEvents);
